
const sortArea = document.querySelector('.js-sort-area');
const conceptArea = document.querySelector('.p-room-concept');
const categorys = [...document.querySelectorAll('.p-room-categorys li')];
let colorChangeContents = [...document.querySelectorAll('.js-sort-area .p-room-contents')];
backgroundColorChange(colorChangeContents);

// 全てのボタンを取得
const buttons = document.querySelectorAll('.select-text');
const displayText = document.getElementById('change-text');

let sortContents = [...document.querySelectorAll('[data-sort]')];
animationClassAdd(sortContents);

categorys.forEach((e) => {
  e.addEventListener('click', () => {
    let idAttribute = e.getAttribute('id');
    classRemove(categorys);
    e.classList.add('is-current');

    if(idAttribute === 'all'){
      conceptArea.style.display = 'block';
    } else {
      conceptArea.style.display = 'none';
    }
    
    let createHtml = ``;

    for(let i = 0; i < sortContents.length; i++){

      let sortAttribute = sortContents[i].getAttribute('data-sort');

      if(sortAttribute.includes(idAttribute)){
        createHtml += sortContents[i].innerHTML;
      }
    }
    
    sortArea.innerHTML = createHtml;
  })
});

function classRemove(array){
  array.forEach((element) => {
    element.classList.remove('is-current');
  })
};

function backgroundColorChange(array) {
  array.forEach((element, index) => {
    if(index % 2 !== 0) {
      element.classList.add('js-change-color');
    }
  })
}

function animationClassAdd(array) {
  array.forEach((element) => {
    element.children[0].classList.add('p-room-contents-animation');
  })
}

// 各ボタンにクリックイベントを追加
buttons.forEach(button => {
  button.addEventListener('click', function() {
    // data-text属性の値を取得して表示テキストを更新
    const changeText = this.getAttribute('data-text');
    displayText.textContent = `${changeText}が選択されています`;
  });
});